import { useEffect } from 'react'

export default function usePageTitle (title: string) {
  const BASE_TITLE = 'K2SNews'
  useEffect(() => {
    document.title = `${BASE_TITLE} - ${title}`
  }, []) // eslint-disable-line
}
